import styled from 'styled-components';
import { upTo } from 'js/services/MediaQuery';

import { breakpoint } from './Card';

export default styled.div`
  display: none;
  margin-top: 10px;

  ${upTo(breakpoint)`
    display: block;
  `}
`;
